/* 1 Oct (Steve): every collection card photo (and Samples card) the same size. Supplier photos leave different amounts of white
   around the garment, so each card photo is measured (where the garment actually is) and zoomed/centred so the
   garment fills the same share of the square. Uses the CSS `scale` / `translate` properties (the card's
   `transform: none` rule stays). Photos that can't be read are left as they are. */
(function () {
  var FILL = 0.84, MIN = 0.8, MAX = 1.9, SEL = ".product-grid__card .card-gallery img, .sts__cimg img";
  var cache = {};
  function box(src, done) {
    if (cache[src]) return done(cache[src]);
    var im = new Image(); im.crossOrigin = "anonymous";
    im.onload = function () {
      try {
        var W = 120, H = Math.max(1, Math.round(W * im.naturalHeight / im.naturalWidth));
        var c = document.createElement("canvas"); c.width = W; c.height = H;
        var x = c.getContext("2d", { willReadFrequently: true }); x.drawImage(im, 0, 0, W, H);
        var d = x.getImageData(0, 0, W, H).data, bg = [d[0], d[1], d[2]];
        var x0 = W, y0 = H, x1 = -1, y1 = -1;
        for (var y = 0; y < H; y++) for (var i = 0; i < W; i++) {
          var k = (y * W + i) * 4; if (d[k + 3] < 20) continue;
          if (Math.abs(d[k] - bg[0]) + Math.abs(d[k + 1] - bg[1]) + Math.abs(d[k + 2] - bg[2]) < 36) continue;
          if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y;
        }
        cache[src] = x1 < 0 ? null : { x0: x0 / W, x1: (x1 + 1) / W, y0: y0 / H, y1: (y1 + 1) / H, r: im.naturalWidth / im.naturalHeight };
      } catch (e) { cache[src] = null; }
      done(cache[src]);
    };
    im.onerror = function () { cache[src] = null; done(null); };
    im.src = src;
  }
  function fit(img) {
    var src = img.currentSrc || img.src; if (!src || img.dataset.stFit === src) return;
    img.dataset.stFit = src;
    box(src, function (b) {
      if (!b) return;
      var el = img.getBoundingClientRect(); if (!el.width || !el.height) return;
      var er = el.width / el.height;
      /* object-fit: contain — the photo's share of the element */
      var pw = b.r >= er ? 1 : b.r / er, ph = b.r >= er ? er / b.r : 1;
      var gw = (b.x1 - b.x0) * pw, gh = (b.y1 - b.y0) * ph;
      var cx = ((1 - pw) / 2 + (b.x0 + b.x1) / 2 * pw) - 0.5, cy = ((1 - ph) / 2 + (b.y0 + b.y1) / 2 * ph) - 0.5;
      var s = Math.max(MIN, Math.min(MAX, FILL / Math.max(gw, gh)));
      img.style.scale = s.toFixed(3);
      img.style.translate = (-cx * s * 100).toFixed(2) + "% " + (-cy * s * 100).toFixed(2) + "%";
    });
  }
  function scan(root) { (root || document).querySelectorAll(SEL).forEach(function (img) {
    if (img.complete && img.naturalWidth) fit(img); else img.addEventListener("load", function () { fit(img); }, { once: true });
  }); }
  function boot() {
    scan();
    new MutationObserver(function (m) { if (m.some(function (r) { return r.addedNodes.length; })) scan(); }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener("load", function (e) { if (e.target.matches && e.target.matches(SEL)) fit(e.target); }, true);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
